import React, { useState, useEffect } from "react";
import algoliasearch from "algoliasearch/lite";
import ProgressLoader from "../Common/ProgressLoader";

const { REACT_APP_ALGOLIA_APP_LIST_INDEX_NAME,REACT_APP_ALGOLIA_APP_LINK_LIST_INDEX_NAME } = process.env;

const {
  REACT_APP_ALGOLIA_SEARCH_KEY,
  REACT_APP_ALGOLIA_APP_ID,
} = process.env;

const searchClient = algoliasearch(
  REACT_APP_ALGOLIA_APP_ID || "",
  REACT_APP_ALGOLIA_SEARCH_KEY || ""
);

const AlgoliaHOC = (Component: any, props: any) => {
  const { config = {} } = props;
  const {
    filters = "",
    setDataList = null,
    hitsPerPage = 5000,
    dataList,
    attributesToRetrieve,
    algoliaIndex,
    refresh,
    algoliaLoading = true,
    setAlgoliaLoading = null,
    setAppLinksList = null,
    appLinksList
  } = config;
  const index = searchClient.initIndex(algoliaIndex || "");
  const [loading, setLoading] = useState(!!algoliaLoading);
  const [emptyHits, setEmptyHits] = useState(false);
  const [data, setData] = useState({}); 

  const getAlgolia = async (page = 0) => {
    searchClient.clearCache();
    setLoading(!!algoliaLoading ? true : false);
    const result = await index.search("", {
      filters: filters,
      hitsPerPage,
      page,
      attributesToRetrieve,
      attributesToHighlight: [],
    });

    setData(result);
    setDataList(result.hits);

    if( algoliaIndex === REACT_APP_ALGOLIA_APP_LIST_INDEX_NAME ){
      const appLinkIndex = searchClient.initIndex(REACT_APP_ALGOLIA_APP_LINK_LIST_INDEX_NAME || "");
      const appLinkResult = await appLinkIndex.search("", {
        filters: filters,
        hitsPerPage,
        page,
        attributesToRetrieve,
        attributesToHighlight: [],
      });
  
      setAppLinksList(appLinkResult.hits);
    }

    setAlgoliaLoading(false)
    setEmptyHits(result.hits.length === 0);
    setLoading(false);
  };

  useEffect(() => {
    //searchClient.clearCache();
    if (refresh) {
      searchClient.clearCache();
    }
    if (dataList.length === 0 && !emptyHits) {
      getAlgolia();
    } else {
      const updatedData = {
        ...data,
        hits: JSON.parse(JSON.stringify(dataList)),
      };
      setData(updatedData);
    }
  }, [dataList]);

  return (
    <>
      <ProgressLoader loading={loading} />
      <Component data={data} getAlgolia={getAlgolia} />
    </>
  );
};

export default AlgoliaHOC;
